import { Box, Chip } from '@mui/material';

export type TabFilterOption = { value: string; label: string; count?: number };

type Props = {
  value: string;
  onChange: (value: string) => void;
  options: TabFilterOption[];
  /** Drop the bottom margin when the bar sits inside a toolbar row. */
  noMargin?: boolean;
};

const TabFilterBar = ({ value, onChange, options, noMargin }: Props) => (
  <Box
    sx={{
      display: 'inline-flex',
      flexWrap: 'wrap',
      gap: 0.5,
      p: 0.5,
      mb: noMargin ? 0 : 3,
      borderRadius: '999px',
      bgcolor: (theme) => (theme.palette.mode === 'light' ? '#F1EEFB' : 'action.hover'),
      boxShadow: 'inset 0 1px 3px rgba(98,38,167,0.12)',
    }}
  >
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <Box
          key={opt.value}
          role="button"
          tabIndex={0}
          onClick={() => onChange(opt.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onChange(opt.value); }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
            px: 2,
            py: 0.75,
            borderRadius: '999px',
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 600,
            color: active ? '#fff' : 'text.secondary',
            background: active ? 'linear-gradient(135deg, var(--qs-a, #6226A7), var(--qs-b, #F6A938))' : 'transparent',
            boxShadow: active ? '0 6px 14px rgba(98,38,167,0.35), inset 0 1px 0 rgba(255,255,255,.4)' : 'none',
            transition: 'background .15s, color .15s',
            '&:hover': { bgcolor: active ? undefined : 'action.hover' },
          }}
        >
          {opt.label}
          {typeof opt.count === 'number' && (
            <Chip
              label={opt.count}
              size="small"
              sx={{
                height: 18,
                fontSize: 11,
                bgcolor: active ? 'rgba(255,255,255,0.25)' : 'action.selected',
                color: active ? '#fff' : 'text.secondary',
              }}
            />
          )}
        </Box>
      );
    })}
  </Box>
);

export default TabFilterBar;
